@use "../../styles/variables" as vars;

.support {
  display: grid;
  justify-items: center;
  margin-top: 14px;
  text-align: center;
}

.faqTrigger {
  padding: 1px 3px;
  border: 0;
  background: transparent;
  color: vars.$color-text;
  cursor: pointer;
  font-family: vars.$font-medium;
  font-size: 14px;
  line-height: 1.2;
  text-decoration: underline;
  text-underline-offset: 3px;

  &:hover {
    color: vars.$color-primary;
  }

  &:focus-visible {
    outline: 2px solid vars.$color-secondary;
    outline-offset: 3px;
  }
}

.withContact {
  width: min(100%, 470px);
  margin-right: auto;
  margin-left: auto;
}

.contact {
  display: grid;
  justify-items: center;
  gap: 5px;
  width: 100%;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid vars.$color-border;
  color: vars.$color-muted;
  font-size: 14px;
  line-height: 1.35;

  strong {
    margin-bottom: 2px;
    color: vars.$color-primary;
    font-family: vars.$font-heavy;
    font-size: 16px;
  }

  a {
    color: vars.$color-primary;
    font-family: vars.$font-heavy;
    text-decoration: underline;
    text-underline-offset: 2px;
  }
}

@media (max-width: 600px) {
  .contact {
    font-size: 13px;
  }
}
